import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// In modern Angular, global configurations are typically handled via environment files.
// Adjust this import path to match your project's structure.
import { environment } from '../../environments/environment'; 

@Injectable({
  providedIn: 'root' // This makes the service available app-wide as a singleton
})
export class SystemConfigurationSettingsService {

  // We preserve the nested API object to maintain strict compatibility
  // with how your component currently calls these methods.
  public API = {
    GetSystemConfigurationSettings: (code: string): Observable<any> => {
      return this.http.get(`${environment.authenticationServer}/api/system/configuration/settings/${code}`);
    },

    UpdateSystemConfigurationSettings: (data: any): Observable<any> => {
      return this.http.put(`${environment.authenticationServer}/api/system/configuration/settings/${data.code}`, data);
    },

    DependencyCheck: (): Observable<any> => {
      return this.http.get(`${environment.authenticationServer}/api/system/configuration/settings/dependency/check`);
    }
  };

  // $http is replaced by the modern HttpClient
  constructor(private http: HttpClient) {}
}